if (!customElements.get('dhs-card-variants')) {
  customElements.define('dhs-card-variants', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const select = this.querySelector('select');
      const button = this.querySelector('button');
      const card = this.closest('.dhs-collection-card');
      const update = () => {
        const option = select.selectedOptions[0];
        const available = option?.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = !select.value ? 'Choose options' : available ? 'Add to cart' : 'Out of stock';
        if (!select.value) return;
        card.querySelector('.dhs-collection-card__price').textContent = option.dataset.price;
        const stock = card.querySelector('.dhs-collection-card__stock');
        stock.textContent = available ? 'In stock' : 'Out of stock';
        stock.classList.toggle('is-out', !available);
        stock.setAttribute('aria-live', 'polite');
        card.querySelectorAll('.dhs-collection-card__title, .dhs-collection-card__media').forEach(link => { link.href = option.dataset.url; });
      };
      select.addEventListener('change', update);
      update();
    }
  });
}
